import React, {useState} from "react";
import {ToggleStyled} from "../../../../ui/toggle/toggle-styled";
import {AddToCart} from "../../services/logic-helper";
import {getImgCDNDomain, getJSONFromHtml} from "../../../../domain/common";
import {SubscriptionsVM} from "../../interfaces";
import {Popup} from "../../../../ui/popup/popup";
import ProductPriceFormat from "../../../products/product-price/product-price-format";
import ArrowIcon from "../../../../ui/svg/common/arrow";
import {IListItem} from "../../../list-page/interfaces/interfaces";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";
import {Price} from "../price";
import {PriceDifferent} from "../price-different";

interface IPlansPopupExportedProps {
    product: IListItem,
    sbsIncludedIn: number | undefined,
    data?: string,
    close?: Function,
    needImgCDNDomain?: boolean
}
export const PlansPopupExported = (props : IPlansPopupExportedProps) => {

    //console.log('props: ', props);
    const [IsAnnual, setIsAnnual] = useState(true);

    const _popupData = (getJSONFromHtml(document.getElementById('subscriptions-popup-data')) as SubscriptionsVM);
    if(!_popupData || props?.sbsIncludedIn === undefined)
        return <></>;
    const StarterPlan = IsAnnual ?
        _popupData.subscriptionPlans.filter(plan => plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith("low"))[0] :
        _popupData.subscriptionPlans.filter(plan => plan.sbsTypeID === 1 && plan.tierLowHigh.endsWith("low"))[0];
    const PremiumPlan = IsAnnual ?
        _popupData.subscriptionPlans.filter(plan => plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith("high"))[0] :
        _popupData.subscriptionPlans.filter(plan => plan.sbsTypeID === 1 && plan.tierLowHigh.endsWith("high"))[0];


    //const annualStarterPlan = _popupData.subscriptionPlans.filter(plan => plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith("low"))[0];
    //const annualPremiumPlan = _popupData.subscriptionPlans.filter(plan => plan.sbsTypeID === 2 && plan.tierLowHigh.endsWith("high"))[0];
    //const IsPriceDifferent = annualStarterPlan.skU_MSRP !== annualStarterPlan.skuPrice;
    //if StarterPlan.numberOfFreeDays > 0 --> button's text :  Start Free 7-Day Trial
    //else --> button's text :  Get Access
    const StarterButtonText = StarterPlan.numberOfFreeDays > 0 ? "Start Free "+StarterPlan.numberOfFreeDays+"-day Trial" : "Subscribe Now";
    const PremiumButtonText = PremiumPlan.numberOfFreeDays > 0 ? "Start Free "+PremiumPlan.numberOfFreeDays+"-day Trial" : "Subscribe Now";

    return (

        <Popup iconWidth={"13px"} width={"auto"} height="auto" canBeClosed={true} close={props.close} classes="pl-0 pr-0">
            <div className="flex flex-row items-center py-4 px-8 " style={{"background": "linear-gradient(104.25deg, #1b1261 1.14%, #6a2864 98.69%)"}}>
                <div>
                    <img className="w-20" src={(props?.needImgCDNDomain ? getImgCDNDomain() : '') + props?.product?.thumb} alt={`${props?.product?.documentName}`} />
                </div>
                <div className="text-white pl-4">
                    {props?.product?.documentName}
                    <>
                        {
                            props?.sbsIncludedIn === 1  &&
                            <span> is available in Waves Ultimate</span>
                        }

                        {
                            props?.sbsIncludedIn === 2 &&
                            <span> is available in both Waves Essential & Ultimate</span>
                        }

                        {
                            !props?.sbsIncludedIn && <span>&nbsp;</span>
                        }
                    </>
                </div>
            </div>
            <div className="flex items-center p-6">
                <div className="w-full flex flex-col items-center justify-center bg-dark-blue text-gray-700 px-4">
                    <div className="text-xl font-bold pb-8">Pay annually & save up to <ProductPriceFormat price={49.89}/></div>
                    <div className="mx-2 toggle-switch-popup flex flex-row items-center">
                        <div className={`${!IsAnnual ? "font-bold" : ""}`}>Monthly</div>
                        <div className="mx-2">
                            <ToggleStyled
                                padding={4}
                                handleColor={"#1D1D1D"}
                                width={57}
                                height={29}
                                isToogle={IsAnnual}
                                adaText={IsAnnual ? 'Annually plan selected' : 'Monthly plan selected'}
                                onClick={(isToogle: boolean) => {
                                    sendGAEvent('Toggle',isToogle ? 'Annual' : 'Monthly');
                                    setIsAnnual(isToogle)
                                    }
                                }

                                textStyles={{
                                    margiLeft: '-5px'
                                }}
                            />
                        </div>
                        <div className={`${IsAnnual ? "font-bold" : ""}`}>Annual</div>
                    </div>

                    <div className="w-full flex flex-col md:flex-row items-center justify-center mt-6 mb-6 text-center text-white">
                        <div className="w-full bg-fade-down-blue-popup rounded-xl px-5 pb-12 md:mr-8 mb-8 md:mb-0"
                             style={{backgroundColor: '#333860'}}>
                            <div
                                className="w-full text-2xl mt-8 font-bold font-montserrat">{StarterPlan.tierName}</div>
                            <div className="w-full text-tiny mt-1 px-8">120+ plugins</div>
                            <div className="w-full text-4xl font-bold mt-4">
                               {/* {annualStarterPlan.skU_MSRP === annualStarterPlan.skuPrice && <div>NOT IsPriceDifferent</div>}
                                {annualStarterPlan.skU_MSRP !== annualStarterPlan.skuPrice && <div>IsPriceDifferent</div>}*/}

                                {StarterPlan.skU_MSRP === StarterPlan.skuPrice && <Price plan={StarterPlan} isStarter={true}  isPopup={true}  isAnnual={IsAnnual}/>}
                                {StarterPlan.skU_MSRP !== StarterPlan.skuPrice && <PriceDifferent plan={StarterPlan} isStarter={true}  isPopup={true} isAnnual={IsAnnual} showCounter={true}/>}

                                {/*old code before IsPriceDifferent (StarterPlan.skU_MSRP !== StarterPlan.skuPrice) */}
                                {/*{
                                    !IsAnnual &&
                                    <span><ProductPriceFormat price={StarterPlan.skU_MSRP}/><span
                                        className="text-base font-normal"> / month</span></span>
                                }
                                {
                                    IsAnnual &&
                                    <div><ProductPriceFormat price={(Math.ceil(annualStarterPlan.skU_MSRP)) / 12}/><span
                                        className="text-base font-normal"> / month</span></div>
                                }*/}
                            </div>
                            {/*old code before IsPriceDifferent (StarterPlan.skU_MSRP !== StarterPlan.skuPrice) */}
                            {/*<div>
                                {
                                    IsAnnual &&
                                    <span className="text-yellow-400"><ProductPriceFormat
                                        price={annualStarterPlan.skU_MSRP}/> billed upfront
                                    </span>
                                }
                            </div>*/}
                            <div className="w-full mt-3 py-1 flex items-center justify-center">
                                <button
                                    type="button"
                                    onClick={() => AddToCart(StarterPlan)}
                                    className="text-white no-underline font-medium bg-mid-purple px-8 py-3 rounded-full text-base text-lg w-fit cursor-pointer"
                                    style={{backgroundColor: '#494E74'}}>{StarterButtonText}</button>
                            </div>
                            <div className="border-t mt-10 mb-4">&nbsp;</div>
                            <div
                                className="flex flex-col items-start text-tiny">
                                <div className="flex items-start pb-4 md:pb-2">
                                    <div className="pt-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px"
                                             viewBox="0 0 31 31" fill="none"><title></title>
                                            <ellipse cx="15.4932" cy="15.5" rx="14.9464" ry="14.9531"
                                                     fill="#EFFF00"></ellipse>
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M22.2025 10.8595C21.9721 10.8669 21.753 10.9602 21.5913 11.12L13.4057 19.0298L9.28732 15.0448C9.12177 14.8814 8.8951 14.7868 8.65696 14.7856C8.41882 14.7831 8.19087 14.874 8.02279 15.0362C7.85469 15.1972 7.76046 15.4172 7.76173 15.647C7.76301 15.8767 7.85852 16.0955 8.02915 16.2564L12.7764 20.8497C12.9432 21.0107 13.1686 21.1016 13.4055 21.1016C13.6411 21.1016 13.8678 21.0107 14.0346 20.8497L22.8493 12.3319C23.1117 12.0849 23.1906 11.7076 23.048 11.382C22.9041 11.0564 22.5692 10.8488 22.2024 10.8598L22.2025 10.8595Z"
                                                  fill="#282828" stroke="#282828" strokeWidth="1.03125"></path>
                                        </svg>
                                    </div>
                                    <div className="pl-2 text-left">All plugin updates included</div>

                                </div>
                                <div className="flex items-start pb-4 md:pb-2">
                                <div className="pt-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px"
                                         viewBox="0 0 31 31" fill="none"><title></title>
                                        <ellipse cx="15.4932" cy="15.5" rx="14.9464" ry="14.9531"
                                                 fill="#EFFF00"></ellipse>
                                        <path fillRule="evenodd" clipRule="evenodd"
                                              d="M22.2025 10.8595C21.9721 10.8669 21.753 10.9602 21.5913 11.12L13.4057 19.0298L9.28732 15.0448C9.12177 14.8814 8.8951 14.7868 8.65696 14.7856C8.41882 14.7831 8.19087 14.874 8.02279 15.0362C7.85469 15.1972 7.76046 15.4172 7.76173 15.647C7.76301 15.8767 7.85852 16.0955 8.02915 16.2564L12.7764 20.8497C12.9432 21.0107 13.1686 21.1016 13.4055 21.1016C13.6411 21.1016 13.8678 21.0107 14.0346 20.8497L22.8493 12.3319C23.1117 12.0849 23.1906 11.7076 23.048 11.382C22.9041 11.0564 22.5692 10.8488 22.2024 10.8598L22.2025 10.8595Z"
                                              fill="#282828" stroke="#282828" strokeWidth="1.03125"></path>
                                    </svg>
                                </div>
                                <div className="pl-2 text-left">Selected new plugins added</div>
                            </div>
                            <div className="flex items-start">
                                    <div className="pt-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px"
                                             viewBox="0 0 31 31" fill="none"><title></title>
                                            <ellipse cx="15.4932" cy="15.5" rx="14.9464" ry="14.9531"
                                                     fill="#EFFF00"></ellipse>
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M22.2025 10.8595C21.9721 10.8669 21.753 10.9602 21.5913 11.12L13.4057 19.0298L9.28732 15.0448C9.12177 14.8814 8.8951 14.7868 8.65696 14.7856C8.41882 14.7831 8.19087 14.874 8.02279 15.0362C7.85469 15.1972 7.76046 15.4172 7.76173 15.647C7.76301 15.8767 7.85852 16.0955 8.02915 16.2564L12.7764 20.8497C12.9432 21.0107 13.1686 21.1016 13.4055 21.1016C13.6411 21.1016 13.8678 21.0107 14.0346 20.8497L22.8493 12.3319C23.1117 12.0849 23.1906 11.7076 23.048 11.382C22.9041 11.0564 22.5692 10.8488 22.2024 10.8598L22.2025 10.8595Z"
                                                  fill="#282828" stroke="#282828" strokeWidth="1.03125"></path>
                                        </svg>
                                    </div>
                                    <div className="md:pb-7 pl-2 text-left">2 licenses for activation on 2 machines</div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full bg-fade-down-purple-popup rounded-xl overflow-hidden relative px-5 pb-12"
                             style={{backgroundColor: '#341558'}}>

                            <div
                                className="w-full text-2xl mt-8 font-bold font-montserrat">{PremiumPlan.tierName}</div>
                            <div className="w-full text-tiny mt-1 px-8">240+ plugins</div>
                            <div className="w-full text-4xl font-bold mt-4">
                                {PremiumPlan.skU_MSRP === PremiumPlan.skuPrice && <Price plan={PremiumPlan} isStarter={true}  isPopup={true}  isAnnual={IsAnnual}/>}
                                {PremiumPlan.skU_MSRP !== PremiumPlan.skuPrice && <PriceDifferent plan={PremiumPlan} isStarter={true}  isPopup={true} isAnnual={IsAnnual} showCounter={true}/>}
                                {/*old code before IsPriceDifferent (StarterPlan.skU_MSRP !== StarterPlan.skuPrice) */}
                                {/* {
                                    !IsAnnual &&
                                    <span><ProductPriceFormat price={PremiumPlan.skU_MSRP}/><span
                                        className="text-base font-normal"> / month</span></span>
                                }
                                {
                                    IsAnnual &&
                                    <div><ProductPriceFormat price={(Math.ceil(annualPremiumPlan.skU_MSRP)) / 12}/><span
                                        className="text-base font-normal"> / month</span></div>
                                }*/}
                            </div>
                            {/*old code before IsPriceDifferent (StarterPlan.skU_MSRP !== StarterPlan.skuPrice) */}
                           {/* <div>
                                {
                                    IsAnnual &&
                                    <span className="text-yellow-400"><ProductPriceFormat
                                        price={annualPremiumPlan.skU_MSRP}/> billed upfront</span>
                                }
                            </div>*/}
                            <div className="w-full mt-3 py-1 flex items-center justify-center">
                                <button type={"button"} onClick={() => AddToCart(PremiumPlan)}
                                        className="text-black no-underline font-medium bg-yellow-400  px-8 py-3 rounded-full text-base text-lg w-fit cursor-pointer">{PremiumButtonText}</button>
                            </div>
                            <div className="border-t mt-10 mb-4">&nbsp;</div>
                            <div
                                className="flex flex-col items-start text-tiny">
                                <div className="flex items-start pb-4 md:pb-2">
                                    <div className="pt-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px"
                                             viewBox="0 0 31 31" fill="none"><title></title>
                                            <ellipse cx="15.4932" cy="15.5" rx="14.9464" ry="14.9531"
                                                     fill="#EFFF00"></ellipse>
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M22.2025 10.8595C21.9721 10.8669 21.753 10.9602 21.5913 11.12L13.4057 19.0298L9.28732 15.0448C9.12177 14.8814 8.8951 14.7868 8.65696 14.7856C8.41882 14.7831 8.19087 14.874 8.02279 15.0362C7.85469 15.1972 7.76046 15.4172 7.76173 15.647C7.76301 15.8767 7.85852 16.0955 8.02915 16.2564L12.7764 20.8497C12.9432 21.0107 13.1686 21.1016 13.4055 21.1016C13.6411 21.1016 13.8678 21.0107 14.0346 20.8497L22.8493 12.3319C23.1117 12.0849 23.1906 11.7076 23.048 11.382C22.9041 11.0564 22.5692 10.8488 22.2024 10.8598L22.2025 10.8595Z"
                                                  fill="#282828" stroke="#282828" strokeWidth="1.03125"></path>
                                        </svg>
                                    </div>
                                    <div className="pl-2 text-left">All plugin updates included</div>

                                </div>
                                <div className="flex items-start pb-4 md:pb-2">
                                    <div className="pt-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px"
                                             viewBox="0 0 31 31" fill="none"><title></title>
                                            <ellipse cx="15.4932" cy="15.5" rx="14.9464" ry="14.9531"
                                                     fill="#EFFF00"></ellipse>
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M22.2025 10.8595C21.9721 10.8669 21.753 10.9602 21.5913 11.12L13.4057 19.0298L9.28732 15.0448C9.12177 14.8814 8.8951 14.7868 8.65696 14.7856C8.41882 14.7831 8.19087 14.874 8.02279 15.0362C7.85469 15.1972 7.76046 15.4172 7.76173 15.647C7.76301 15.8767 7.85852 16.0955 8.02915 16.2564L12.7764 20.8497C12.9432 21.0107 13.1686 21.1016 13.4055 21.1016C13.6411 21.1016 13.8678 21.0107 14.0346 20.8497L22.8493 12.3319C23.1117 12.0849 23.1906 11.7076 23.048 11.382C22.9041 11.0564 22.5692 10.8488 22.2024 10.8598L22.2025 10.8595Z"
                                                  fill="#282828" stroke="#282828" strokeWidth="1.03125"></path>
                                        </svg>
                                    </div>
                                    <div className="pl-2 text-left">New plugins added regularly</div>
                                </div>
                                <div className="flex items-start pb-4 md:pb-2">
                                    <div className="pt-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px"
                                             viewBox="0 0 31 31" fill="none"><title></title>
                                            <ellipse cx="15.4932" cy="15.5" rx="14.9464" ry="14.9531"
                                                     fill="#EFFF00"></ellipse>
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M22.2025 10.8595C21.9721 10.8669 21.753 10.9602 21.5913 11.12L13.4057 19.0298L9.28732 15.0448C9.12177 14.8814 8.8951 14.7868 8.65696 14.7856C8.41882 14.7831 8.19087 14.874 8.02279 15.0362C7.85469 15.1972 7.76046 15.4172 7.76173 15.647C7.76301 15.8767 7.85852 16.0955 8.02915 16.2564L12.7764 20.8497C12.9432 21.0107 13.1686 21.1016 13.4055 21.1016C13.6411 21.1016 13.8678 21.0107 14.0346 20.8497L22.8493 12.3319C23.1117 12.0849 23.1906 11.7076 23.048 11.382C22.9041 11.0564 22.5692 10.8488 22.2024 10.8598L22.2025 10.8595Z"
                                                  fill="#282828" stroke="#282828" strokeWidth="1.03125"></path>
                                        </svg>
                                    </div>
                                    <div className="pl-2 text-left">2 licenses for activation on 2 machines</div>
                                </div>
                                <div className="flex items-start">
                                    <div className="pt-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px"
                                             viewBox="0 0 31 31" fill="none"><title></title>
                                            <ellipse cx="15.4932" cy="15.5" rx="14.9464" ry="14.9531"
                                                     fill="#EFFF00"></ellipse>
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                  d="M22.2025 10.8595C21.9721 10.8669 21.753 10.9602 21.5913 11.12L13.4057 19.0298L9.28732 15.0448C9.12177 14.8814 8.8951 14.7868 8.65696 14.7856C8.41882 14.7831 8.19087 14.874 8.02279 15.0362C7.85469 15.1972 7.76046 15.4172 7.76173 15.647C7.76301 15.8767 7.85852 16.0955 8.02915 16.2564L12.7764 20.8497C12.9432 21.0107 13.1686 21.1016 13.4055 21.1016C13.6411 21.1016 13.8678 21.0107 14.0346 20.8497L22.8493 12.3319C23.1117 12.0849 23.1906 11.7076 23.048 11.382C22.9041 11.0564 22.5692 10.8488 22.2024 10.8598L22.2025 10.8595Z"
                                                  fill="#282828" stroke="#282828" strokeWidth="1.03125"></path>
                                        </svg>
                                    </div>
                                    {IsAnnual &&
                                        <div className="pl-2 text-left">30 Mastering credits added every year</div>}
                                    {!IsAnnual &&
                                        <div className="pl-2 text-left">2 Mastering credits added every month</div>}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="flex items-center pt-1">
                        <a href="/subscriptions" className="text-xl font-bold text-gray-700 pr-1"
                           onClick={evt => {
                               sendGAEvent('Click', 'See full comparison')
                           }}
                        >See full comparison</a>
                        <ArrowIcon
                            width="14px"
                            color="bg-gray-700"
                            title="Arrow Down"
                            rotationAngle={-90}
                        />
                    </div>
                </div>
            </div>


        </Popup>

    )
};